import { render, staticRenderFns } from "./FormGetProductBySkuList.vue?vue&type=template&id=dbfc5924&scoped=true&"
import script from "./FormGetProductBySkuList.vue?vue&type=script&lang=js&"
export * from "./FormGetProductBySkuList.vue?vue&type=script&lang=js&"
import style0 from "./FormGetProductBySkuList.vue?vue&type=style&index=0&id=dbfc5924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfc5924",
  null
  
)

export default component.exports